// src/guide/telechargements/guide_telechargements.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_telechargements(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.telechargement.barreNavigation.titre,
    translations.telechargement.barreNavigation.texte,
    `#${(document.querySelector(
      '[id^="pv_id_"][id$="_0_header_action"]'
    ).parentElement.parentElement.id = "barre_navigation_telechargement")}`,
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.telechargement.liste_telechargement.titre,
    translations.telechargement.liste_telechargement.texte,
    "#liste_telechargement",
    "top"
  );

  tour.start();
}
